var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-main',[_c('v-row',{staticClass:"ma-0"},[_c('v-col',{attrs:{"cols":"12","md":"3"}},[_c('sidebar')],1),_c('v-col',{attrs:{"cols":"12","md":"9"}},[_vm._t("default")],2)],1)],1),_c('page-loader'),_c('snackbar-message')],1)}
var staticRenderFns = []

export { render, staticRenderFns }